<style lang="sass">
#navigation-inner
  display: flex
  justify-content: space-between
  align-items: flex-end
  position: relative
  width: 100vw
  height: calc(var(--navigation-height) + var(--status-bar-height))
  z-index: 0

  #left-action, #right-action
    height: calc(var(--navigation-height) - var(--navigation-height) * .2)
    width: calc(var(--navigation-height) - var(--navigation-height) * .2)
    padding: calc(var(--navigation-height) * .1)
    cursor: pointer
    &.icon-close
      height: calc(var(--navigation-height) - var(--navigation-height) * .4)
      width: calc(var(--navigation-height) - var(--navigation-height) * .4)
      padding: calc(var(--navigation-height) * .2)
    &.icon-chat, &.icon-chat-notification
      height: calc(var(--navigation-height) - var(--navigation-height) * .4)
      width: calc(var(--navigation-height) - var(--navigation-height) * .4)
      padding: calc(var(--navigation-height) * .2)
  #center-action-wrapper
    position: absolute
    left: 0
    width: 100%
    height: 100%
    display: flex
    justify-content: center
    align-items: center
    z-index: -1
    #center-action
      height: calc(var(--navigation-height) - 2 * calc(var(--navigation-height) * .25))
      padding: calc(var(--navigation-height) * .15)
      z-index: 1
      cursor: pointer
</style>
<template>
  <div id="navigation">
    <transition name="tray-left" appear>
      <left-side-menu v-if="menuOpen" :handle-close="toggleMenu"></left-side-menu>
    </transition>
    <div id="navigation-inner">
      <transition name="fade-quickly" mode="out-in">
        <img id="left-action"
            :key="config.leftImg"
            v-if="config.leftEnabled"
            :src="require(`../assets/images/${config.leftImg}`)"
            @click="handleLeftClick"
            :class="`${classNameFromFileName(config.leftImg)}`"
            />
      </transition>
      <div id="placeholder"></div>
      <div id="center-action-wrapper" v-if="config.centerEnabled">
        <img id="center-action" src="../assets/images/logo-small.png" v-on:click="handleCenterClick" />
      </div>
      <transition name="fade" mode="out-in">
        <img id="right-action"
            v-if="config.rightEnabled"
            :src="require(`../assets/images/${config.rightImg}`)"
            @click="handleRightClick"
            :class="`${classNameFromFileName(config.rightImg)}`"
            />
      </transition>
    </div>
  </div>
</template>
<script>
import LeftSideMenu from './left-side-menu.vue';

export default {
  name: 'Navigation',
  components: {
    LeftSideMenu
  },
  data: function() {
    return {
      menuOpen: false
    };
  },
  computed: {
    config: function() {
      return this.$store.state.navigation;
    }
  },
  methods: {
    handleLeftClick: function() {
      if (this.config.leftHandler) {
        this.config.leftHandler();
      } else if (this.config.leftRoute) {
        this.$router.push(this.config.leftRoute);
      } else {
        this.toggleMenu();
      }
    },
    handleRightClick: function() {
      if (this.config.rightHandler) {
        this.config.rightHandler();
      } else if (this.config.rightRoute) {
        this.$router.push(this.config.rightRoute);
      } else {
        this.$router.go(1);
      }
    },
    handleCenterClick: function() {
      this.$router.push({name: 'dashboard'});
    },
    toggleMenu: function() {
      this.menuOpen = !this.menuOpen;
    },
    classNameFromFileName(fileName) {
      return (fileName || '').replace(/\.\w+$/, '');
    }
  }
};
</script>
